// extracted by mini-css-extract-plugin
module.exports = {"main":"Dashboard_main__1KF3_","loadingScreen":"Dashboard_loadingScreen__1zTkz","sampleCharts":"Dashboard_sampleCharts__cxI1b"};